import AppUpdateDetector from "@components/utils/AppUpdateDetector";
import MemberSettingsLoader from "@components/utils/MemberSettingsLoader";
import ThemeColorLoader from "@components/utils/ThemeColorLoader";
import { ThemePreset } from "@configs/theme-preset";
import { store } from "@stores";
import "@styles/App.css";
import { ThemeProvider } from "kz-ui-sdk";
import "kz-ui-sdk/dist/sdk-themes.css";
import "react-aspect-ratio/aspect-ratio.css";
import { Provider } from "react-redux";
import AppRoutes from "./AppRouter";
import "./configs/i18n";

function App() {
  return (
    <ThemeProvider
      value={{
        preset: ThemePreset,
      }}
    >
      <Provider store={store}>
        <ThemeColorLoader />
        <MemberSettingsLoader>
          <AppRoutes />
        </MemberSettingsLoader>
        <AppUpdateDetector />
      </Provider>
    </ThemeProvider>
  );
}

export default App;
